module.exports = __webpack_public_path__ + "static/media/individual.aba51a3a.pdf";